import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography , Menu , MenuItem } from "@mui/material";
import {EditOutlined ,DeleteOutline , History} from "@mui/icons-material";
import { DataGrid  } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import _ from "lodash";
import { CUSTOM_CONSTANTS } from "Constants";

//Services
import UserwalletApi from "Services/Wallet"

const UserWallet = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //

  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);  
  const [currentRowData, setCurrentRowData] = useState({}); // State to hold the current row data
  const [customerId, setCustomerId] = useState("");

  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlewalletdetails = (currentRowData) =>{
    //  console.log('currentRowData-->',currentRowData);
    navigate(`/driver-wallet-logs/${currentRowData._id}/${currentRowData.userId}`);
  }
  //Modals

  // Get userWallet list api
  const getuserWalletlist = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
       // console.log('Wallet-datas-->',res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    UserwalletApi
      .getdriverWalletList({ page, limit: pageSize })
      .then(onSuccess, onFailure);
  }, [page, pageSize]);

  const getalluserWalletlist = useCallback(() => {
   // dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
     // dispatch(hideLoader());
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data);
       // console.log('Wallet-datas-->',res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    UserwalletApi
      .getdriverWalletList({ page:1, limit: "unlimited" })
      .then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    getuserWalletlist();
    getalluserWalletlist();
  }, [getuserWalletlist]);

  const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All DriverwalletList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }; 

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const handleCopy = () => {
      // Define column widths
      const columnWidths = [5, 15, 25, 15, 15]; // Adjust widths as needed
  
      // Helper function to pad text to the desired width
      const padText = (text, width) => {
        return (text ?? "").toString().padEnd(width, " ");
      };
      // Create table header
      const header = [
        padText("S.NO", columnWidths[0]),
        padText("User Name", columnWidths[1]),
        padText("Email", columnWidths[2]),
        padText("Mobile", columnWidths[3]),
        padText("Wallet", columnWidths[4])
      ].join("");
    
      // Create table rows
      const rows = dataRows
        .map((row) =>
          [
            padText(row.sno, columnWidths[0]),
            padText(row.username, columnWidths[1]),
            padText(row.email, columnWidths[2]),
            padText(row.mobile, columnWidths[3]),
            padText(row.wallet, columnWidths[4])
          ].join("")
        )
        .join("\n");
    
      // Combine header and rows
      const formattedContent = [header, rows].join("\n");
    
      // Copy to clipboard
      navigator.clipboard.writeText(formattedContent).then(() => {
        alert("Table copied to clipboard!");
      });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "Driverwallet.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Driverwallet.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,
      row.username,
      row.email,
      row.mobile,
      row.wallet
    ]);
    doc.autoTable({
      head: [["S.NO","User Name","Email","Mobile","wallet"]],
      body: tableData,
    });
    doc.save("Driverwallet.pdf");
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

const dataRows = _.map(
  (row || []).filter(data => data?.userdetails?.user_name), // Filter out rows with empty or undefined username
  (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    username: data?.userdetails?.user_name,
    email: data?.userdetails?.email,
    mobile: data?.userdetails?.countryCode+" "+data?.userdetails?.mobileNumber,
    wallet:  (data?.walletlogdetails || []).reduce(
      (sum, log) => sum + (log?.creditedAmount ? log?.creditedAmount: 0),0),
    row: data,
  }));

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "User Name":row.username,
    "Email":row.email,
    "Mobile": row.mobile,
    "wallet": row.wallet
  }));
  
  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ['createdAt'], ['asc']),
    (data, index) => ({
   sno: calculateSno(page, pageSize, index),
    username: data?.userdetails?.user_name,
    email: data?.userdetails?.email,
    mobile: data?.userdetails?.countryCode+" "+data?.userdetails?.mobileNumber,
    wallet:  (data?.walletlogdetails || []).reduce(
      (sum, log) => sum + (log?.creditedAmount ? log?.creditedAmount: 0),0),
    row: data,
  }));  
  
  const bulkformatteddatas = bulkdataRows.map((row) => ({
     "S.NO": row.sno,
    "User Name":row.username,
    "Email":row.email,
    "Mobile": row.mobile,
    "wallet": row.wallet
  })); 

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex:0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "username",
      headerName: "Name",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
          <Typography variant="body2"  
          onClick={() => handlewalletdetails(params?.row.row)}
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            fontWeight:"bold",
            cursor: "pointer",
            color: "#9c27b0", // Optional: Color to indicate it's clickable
          }}>{params?.row?.username}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.email}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.mobile}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "wallet",
      headerName: "Wallet",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{(params?.row?.wallet).toFixed(2)+" "+CUSTOM_CONSTANTS.BASE_CURRENCY}</Typography>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleCopy}>
            COPY
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadExcel}>
            EXCEL
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadCSV}>
            CSV
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadPDF}>
            PDF
          </Button>
        </Grid>
         <Grid item xs={2} md={2} lg={2} xl={2} className={classes.funBtn}>
              <Button variant="contained" onClick={handleDownloadAll}>
              Download ALL
              </Button>
              </Grid>  
      </Grid>

        <Grid container className={classes.walletdetails}>
        <Grid item xs={12}>
          <section className={classes.dataGridTable}>
            <DataGrid
              getRowId={(row) => row?.row?._id}
              rows={dataRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
                setPage(1);
              }}
              onPageChange={(newPage) => handlePageChange(newPage)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
              paginationMode="server"
              rowCount={totalPages}
            />
          </section>
        </Grid>
      </Grid>
    </>
  );
};

export default UserWallet;
